export const styles = {
	copyContainer: {
		display: 'flex',
		marginLeft: '0.5rem',
	},
	copy: {
		marginLeft: '0.5rem',
		color: 'rgba(0,0,0,0.6)',
		fontSize: '1.6rem',
		transition: 'font-size 0.3s, text-shadow 0.3s',
	},
	flame: {
		margin: '0 0.4rem',
	},
	ideaCount: {
		fontWeight: 500,
		fontSize: '1.5rem',
		lineHeight: '2.6rem',
		transition: 'font-size 0.3s, text-shadow 0.3s',
	},
	motivator: {
		display: 'flex',
		alignItems: 'center',
	},
	highlightedIdeaCount: (flameColor: string) => ({
		fontSize: '2rem',
		textShadow: `0 0 8px ${flameColor}, 0 0 2px #fff`,
	}),
	motivationCopyShadow: (flameColor: string) => ({
		textShadow: `0 0 8px ${flameColor}, 0 0 2px #fff`,
		fontSize: '2.2rem',
		transform: 'translateY(-3px)',
	}),
}
